import { getRouteApi, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

import { definedSearchParams } from '@/lib/search-params';

import { AiSpendScreen } from './AiSpendScreen';
import type { AiSpendSearch } from './ai-spend-search';

const route = getRouteApi('/ai-spend');

export function AiSpendRoute() {
  const search = route.useSearch();
  const navigate = route.useNavigate();
  const navigateApp = useNavigate();

  const onSearchChange = useCallback(
    (next: AiSpendSearch) => {
      void navigate({ replace: true, search: () => definedSearchParams(next) });
    },
    [navigate],
  );

  const onOpenUser = useCallback(
    (userId: string) => {
      // Straight to the tab that explains the row they clicked, over the same window.
      void navigateApp({
        to: '/users/$userId',
        params: { userId },
        search: { tab: 'ai', aiDays: search.days },
      });
    },
    [navigateApp, search.days],
  );

  return <AiSpendScreen search={search} onSearchChange={onSearchChange} onOpenUser={onOpenUser} />;
}
